var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-panel"},[_c('PanelHeader',{attrs:{"sidebar":false}}),_vm._t("bradcrumbs"),_c('section',{staticClass:"body",class:{'body-height': _vm.bodyHeight}},[_vm._t("content")],2),_c('ui-feedback-modal'),_c('ui-thank-feedback-modal'),_c('ui-active-offer-modal'),_c('uiRatingNPS')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }